import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=418abf9e&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=418abf9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418abf9e",
  null
  
)

export default component.exports